import * as yup from 'yup';

import { RoomHistory } from 'models/index';

import { endpoint, EndpointError } from '../endpoint';
import { ValidationShape, ERROR } from '../validation';
import * as Pagination from '../pagination';
import { Model as UserModel } from 'models/user/interface';

export type PaginationParams = Pagination.Params<RoomHistory.Model, null> & { roomId: string };
export type PaginationResult = {
  items: Array<RoomHistory.Model & { userInfo: Array<UserModel> }>;
  page: number;
  pageSize: number;
  totalPages: number;
};
export type PaginationError = EndpointError;

export const paginationParamsSchema = yup.object().shape({
  page: yup.number().positive(ERROR.INVALID_VALUE).required(ERROR.REQUIRED),
  pageSize: yup.number().positive(ERROR.INVALID_VALUE).required(ERROR.REQUIRED),
  search: yup.string(),
  sort: yup.object().shape({
    field: yup
      .string()
      .oneOf(['name', 'conversationsTotal', 'requestSpeakPermission', 'sentReactionTime'], ERROR.INVALID_VALUE),
    direction: yup.string().oneOf(['asc', 'desc'], ERROR.INVALID_VALUE),
  }),
  roomId: yup.string(),
} as ValidationShape<PaginationParams>);

export const paginate = endpoint<PaginationParams, PaginationResult, PaginationError>({
  method: 'POST',
  url: () => `/room-history/paginate`,
});
